import React, { useState } from 'react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Select from 'react-select';
import { colors } from 'assests/colors';
import wrongImg from "../../../assests/images/cross-button.png";
import "./Shortlisted.css"




function Shortlisted() {
    const defaultText = `Hi Thomas Lam,
    
        We’re impressed with your ICU nursing experience and certifications (BLS, ACLS). We’d like to invite you to discuss joining our night shift team.
        Your leadership role in migrating asset compliance demonstrates a strong blend of technical expertise and project management skills that align with our needs.
        
        Are you interested in finding a time to speak this week?
        
        Best,
        David`;

    const [text, setText] = useState(defaultText);

    const Options = [
        { label: "xyz@gmail.com", value: "xyz@gmail.com" },
        { label: "john@gmail.com", value: "john@gmail.com" },
        { label: "sciens@gmail.com", value: "sciens@gmail.com" }
    ]


    const history=useHistory()

    const HandleShortlistedMail=()=>{
    //   history.push('/communication1')
    }

    return (
        <div>
            <Card className="p-4 mb-4">
                <div style={{display:"flex",justifyContent:"space-between"}}>
                <div style={{fontWeight:"bold"}}>Adding Nurse Profiles to staffing Sequence</div>
                <div><Button style={{backgroundColor:`${colors.primary1}`,color:"#fff",borderRadius:"20px"}} onClick={HandleShortlistedMail}>Confirm & Send</Button></div>
                </div>
                <div>
                    <Card>
                        <Row>
                            <Col md="12" lg="12" sm="12">
                                <Form.Label style={{ fontWeight: "bold", fontSize: "18px" }}>Which email addresses do you prefer to contact</Form.Label>
                                <Col md='7' lg="7" sm="7">
                                    <Select
                                        classNamePrefix="react-select"
                                        options={Options}
                                        placeholder="Prefer Personal emails"
                                        style={{ backgroundColor: "lightcyan" }}
                                    />
                                </Col>
                            </Col>
                        </Row>
                        <Row className='mt-3'>
                            <Form.Label style={{ fontWeight: "bold", fontSize: "18px" }}>Review Your Emails (4)</Form.Label>
                            <Col md="12" lg="12" sm="12" className='p-3 rounded' >
                                <Row>
                                    <Col sm="12" md="2" lg="2" className='rounded ms-1 mt-1' style={{ backgroundColor: "lightcyan" }}>
                                        <div style={{ fontSize: "14px", textAlign: "center", paddingTop: "2px" }}>Maanvitha Gongalla <img src={wrongImg} alt='' style={{ width: "10px", height: "10px" }} /></div>
                                    </Col>
                                    <Col sm="12" md="2" lg="2" className='rounded ms-1 mt-1' style={{ backgroundColor: "lightcyan" }}>
                                        <div style={{ fontSize: "14px", textAlign: "center", paddingTop: "2px" }}>Thomas Lam <img src={wrongImg} alt='' style={{ width: "10px", height: "10px" }} /></div>
                                    </Col>
                                </Row>
                            </Col>
                            <div className='mt-2'>Maanvitha Gongalla</div>
                            <div>Registered Nurse(ICU)er at DoorDash</div>
                        </Row>
                        <Row className='mt-2'>
                            <Form.Label style={{ fontWeight: "bold", fontSize: "18px" }}>Subject</Form.Label>
                            <Col md="7" lg="7" sm="12" xs="12">
                                <Form.Control placeholder='write Subject here' style={{backgroundColor:"lightcyan"}} />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Form.Label style={{ fontWeight: "bold", fontSize: "18px" }}>Email Context</Form.Label>
                            <Col sm="12" md="7" lg="7">
                                <Form.Control as="textarea" rows={15} value={text} onChange={(e) => setText(e.target.value)}  style={{backgroundColor:"lightcyan"}}/>
                            </Col>
                            <div className='mt-2'>Thomas Lam</div>
                            <div>Registered Nurse(ICU)er at DoorDash</div>
                        </Row>


                        <Row className='mt-2'>
                            <Form.Label style={{ fontWeight: "bold", fontSize: "18px" }}>Subject</Form.Label>
                            <Col md="7" lg="7" sm="12" xs="12">
                                <Form.Control placeholder='write subject here'  style={{backgroundColor:"lightcyan"}}/>
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Form.Label style={{ fontWeight: "bold", fontSize: "18px" }}>Email Context</Form.Label>
                            <Col sm="12" md="7" lg="7">
                                <Form.Control as="textarea" rows={15} value={text} onChange={(e) => setText(e.target.value)} style={{backgroundColor:"lightcyan "}} />
                            </Col>
                        </Row>                       
                    </Card>
                </div>

            </Card>
        </div>
    )
}

export default Shortlisted